/* eslint-disable prefer-destructuring */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { withRouter } from 'react-router-dom';

import { sportTypeIds } from '../../../utils/eventConstants';
import SectionHeading from '../../../components/text/SectionHeading';
import SectionHeadingWrapper from '../../../components/text/SectionHeading/HeadingWrapper';
import { EventCard } from '../../../components/cards';

import { getPlayerCreatedPlays, applySearchFilters } from '../../../actions/search-actions';
import { acceptInvite, declineInvite, getEvent } from '../../../actions/event-actions';

const PlayerCreatedPlaysNearMe = (props) => {
    // component props
    const { filterPreferences } = props;
    // redux mapping
    const { playerCreatedPlays = [], loading, auth } = props;

    useEffect(() => {
        if (!loading) {
            props.getPlayerCreatedPlays(filterPreferences);
        }
    }, [filterPreferences]);

    const onViewAllClick = () => {
        const { location, lat, lng, distance, sportTypes } = filterPreferences;
        props.applySearchFilters({
            type: 'events',
            eventTypes: { group_play: true },
            startDate: moment(new Date()),
            distance,
            location,
            lat,
            lng,
            sportTypes,
        }, true);
        props.history.push('/search?type=events&eventTypes=group_play');
    };

    const handleOnInviteClick = async (clickEvent, event, isAccepting) => {
        clickEvent.stopPropagation();
        clickEvent.preventDefault();
        const eventId = event.id;
        await props.getEvent(eventId, false, false, false);
        const divisionId = props.events.currentEvent.data.eventDivisions[0].id;

        if (isAccepting) {
            await props.acceptInvite(eventId, divisionId, true);
            props.history.push({ pathname: `/events/${eventId}`, state: { hasAccepted: true } });
        } else {
            await props.declineInvite(eventId, divisionId, true);
            props.history.push(`/events/${eventId}`);
        }
    };

    const { feedPreferences: { showTennisContent, showPickleballContent } } = auth;
    const filteredPlayerCreatedPlays = playerCreatedPlays.filter(event => {
        return (!!showTennisContent && event.sportTypeId === sportTypeIds.TENNIS) ||
            (!!showPickleballContent && event.sportTypeId === sportTypeIds.PICKLEBALL);
    });

    return (
        <div>
            <div className="row mt64">
                <div className="col-12">
                    <SectionHeadingWrapper>
                        <SectionHeading title={'Player Created Plays Near Me'} data-testid="dashboard.player-created-plays.section-heading" />
                        <div className={`link clickable`} onClick={onViewAllClick} data-testid="dashboard.player-created-plays.view-all-btn">
                            View All
                        </div>
                    </SectionHeadingWrapper>
                </div>
            </div>
            <div className="row">
                {filteredPlayerCreatedPlays?.length ? (
                    filteredPlayerCreatedPlays.map((hit) => {
                        return (
                            <div
                                className={`col-12 col-md-6 col-xl-4`}
                                key={hit.source.id}
                            >
                                <EventCard
                                    event={hit.source}
                                    auth={auth}
                                    force={{
                                        cardView: true,
                                    }}
                                    showInvitation={true}
                                    invitingMember={hit.source.eventDirectors[0]}
                                    onAcceptClick={(clickEvent) => handleOnInviteClick(clickEvent, hit.source, true)}
                                    onDeclineClick={(clickEvent) => handleOnInviteClick(clickEvent, hit.source, false)}
                                    data-testid={`dashboard.player-created-plays.item-${hit.source.id}`}
                                />
                            </div>
                        );
                    })
                ) : (
                    <div className="col" data-testid="dashboard.player-created-plays.empty-message">There are no player created plays in your area</div>
                )}
            </div>
        </div>
    );
};

PlayerCreatedPlaysNearMe.propTypes = {
    playerCreatedPlays: PropTypes.instanceOf(Array),
    loading: PropTypes.bool,
    auth: PropTypes.instanceOf(Object).isRequired,
};

PlayerCreatedPlaysNearMe.defaultProps = {
    playerCreatedPlays: [],
    loading: false,
};

function mapStateToProps({ homepage, auth, events }) {
    const { playerCreatedPlays = {} } = homepage;
    const { data, loading, error } = playerCreatedPlays;
    return { playerCreatedPlays: data, events, loading, error, auth };
}
const mapDispatchToProps = {
    getPlayerCreatedPlays,
    applySearchFilters,
    acceptInvite,
    declineInvite,
    getEvent,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PlayerCreatedPlaysNearMe));
